// Logika murni cascading wilayah — dipisah dari komponen agar mudah diuji.
// Memilih induk mereset seluruh anak agar kombinasi kode selalu konsisten.

export type Region = { id: string; name: string }

export type RegionValue = {
  idProvince: string
  idRegency: string
  idDistrict: string
}

export const EMPTY_REGION: RegionValue = {
  idProvince: '',
  idRegency: '',
  idDistrict: '',
}

/** Ubah data referensi menjadi opsi Mantine Select. */
export function toRegionOptions(data: Region[] | undefined) {
  return (data || []).map((r) => ({ value: r.id, label: r.name }))
}

/** Pilih provinsi → reset kabupaten & kecamatan. */
export function selectProvince(idProvince: string | null): RegionValue {
  return { idProvince: idProvince || '', idRegency: '', idDistrict: '' }
}

/** Pilih kabupaten/kota → pertahankan provinsi, reset kecamatan. */
export function selectRegency(current: RegionValue, idRegency: string | null): RegionValue {
  return { ...current, idRegency: idRegency || '', idDistrict: '' }
}

/** Pilih kecamatan → pertahankan provinsi & kabupaten. */
export function selectDistrict(current: RegionValue, idDistrict: string | null): RegionValue {
  return { ...current, idDistrict: idDistrict || '' }
}

/** Wilayah lengkap jika ketiga kode terisi. */
export function isRegionComplete(value: RegionValue): boolean {
  return !!value.idProvince && !!value.idRegency && !!value.idDistrict
}
